import { SIZES_OPTIONS } from "constants/options";
import { Option } from "ui";

import { AttributeValue } from "../categories.types";

export const getSizesOptionsWithDisabling = (
  selectableSizesValues: AttributeValue[]
): Option[] => {
  const optionsWithServerDisabling = SIZES_OPTIONS.map((option) => {
    const optionInSelectableList = selectableSizesValues.find(
      (selectedValue) => selectedValue.value === option.value
    );

    return {
      ...option,
      disabled: optionInSelectableList?.isValidToDelete === false
    };
  });

  const isNoSizesSelected = selectableSizesValues.some(
    (value) => value.value === "NO SIZES" && !value.delete
  );

  const isSomeSizesSelected = selectableSizesValues.some(
    (value) => value.value !== "NO SIZES" && !value.delete
  );

  if (isNoSizesSelected) {
    return optionsWithServerDisabling.map((sizeOption) => ({
      ...sizeOption,
      disabled: sizeOption.disabled || sizeOption.value !== "NO SIZES"
    }));
  }

  if (isSomeSizesSelected) {
    return optionsWithServerDisabling.map((sizeOption) => ({
      ...sizeOption,
      disabled: sizeOption.disabled || sizeOption.value === "NO SIZES"
    }));
  }

  return SIZES_OPTIONS;
};
